<ion-header>
  <ion-toolbar mode="ios">
    <ion-button (click)="close()" fill="clear" color="dark" class="ion-no-padding">
      <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
    </ion-button>
    <ion-title class="ion-no-padding">
      <ion-img [src]="dataServ.rData.dark_logo" *ngIf="dataServ.rData && dataServ.rData.dark_logo[0]"></ion-img>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

  <ion-grid class="form">

    <!-- <img src="assets/img/logo-outline.svg" class="outline"> -->

    <ion-row>
      <ion-col size="12">
        <ion-text color="primary" class="ion-text-center">
          <h1><b>
              {{(data ? data.survey_title : notificationData ? notificationData.title : richData.survey_title) | caption
              | translate}}
            </b></h1>
        </ion-text>
      </ion-col>
      <ion-col size="12">
        <ion-text color="dark" class="ion-text-center contentt">
          <h3>
            {{(data ? data.survey_description : notificationData ? notificationData.description :
            richData.survey_description) | sanitizeHtml | caption | translate }}</h3>
        </ion-text>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12" class="stars">
        <ng-container *ngFor="let i of [1,2,3,4,5]">
          <div class="star {{i <= rate ? 'active' : ''}}" (click)="rate = i"></div>
        </ng-container>
      </ion-col>
      <ion-col size="12">
        <ion-button [disabled]="processing" (click)="send()" expand="block" color="primary">
          <ion-spinner name="lines" *ngIf="processing" slot="start"></ion-spinner>
          {{'Send' | translate}}
        </ion-button>
      </ion-col>
    </ion-row>

  </ion-grid>
</ion-content>